<template>
  <v-footer
    tile
    height="60"
    class="font-weight-medium shadow-sm ma-4 rounded-lg"
    :color="$vuetify.theme.dark ? 'dark' : 'white'"
    :dark="$vuetify.theme.dark"
    :inset="true"
  >
    <v-col class="text-left" cols="12">
      <div class="d-flex flex-row justify-space-between align-center">
        <a href="https://tiq.one" target="_blank" class="text--disabled">
          <img
            v-if="$vuetify.theme.dark"
            height="24"
            src="/img/logo/logo-dark.png"
            alt=""
          />
          <img v-else height="24" src="/img/logo/logo-light.png" alt="" />
        </a>
        <v-btn
          text
          x-small
          class="text--disabled"
          target="_blank"
          href="mailto:contato@tiq.one"
        >
          Contato
        </v-btn>
      </div>
    </v-col>
  </v-footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getThemeMode"]),
  },
};
</script>
